__turbopack_context__.v({
  "checkbox": "ApplyFormGuardianConsent-module__k1CUkq__checkbox",
  "checkboxError": "ApplyFormGuardianConsent-module__k1CUkq__checkboxError",
  "checkboxIcon": "ApplyFormGuardianConsent-module__k1CUkq__checkboxIcon",
  "checkboxLabel": "ApplyFormGuardianConsent-module__k1CUkq__checkboxLabel",
  "consentText": "ApplyFormGuardianConsent-module__k1CUkq__consentText",
  "container": "ApplyFormGuardianConsent-module__k1CUkq__container",
  "fadeInItems": "ApplyFormGuardianConsent-module__k1CUkq__fadeInItems",
  "field": "ApplyFormGuardianConsent-module__k1CUkq__field",
  "input": "ApplyFormGuardianConsent-module__k1CUkq__input",
  "spacing--lg": "ApplyFormGuardianConsent-module__k1CUkq__spacing--lg",
  "spacing--md": "ApplyFormGuardianConsent-module__k1CUkq__spacing--md",
  "spacing--sm": "ApplyFormGuardianConsent-module__k1CUkq__spacing--sm",
  "spacing--xl": "ApplyFormGuardianConsent-module__k1CUkq__spacing--xl",
  "spacing--xs": "ApplyFormGuardianConsent-module__k1CUkq__spacing--xs",
  "spacing--xxl": "ApplyFormGuardianConsent-module__k1CUkq__spacing--xxl",
  "spacing--xxs": "ApplyFormGuardianConsent-module__k1CUkq__spacing--xxs",
  "spacing--xxxl": "ApplyFormGuardianConsent-module__k1CUkq__spacing--xxxl",
  "spacing--xxxs": "ApplyFormGuardianConsent-module__k1CUkq__spacing--xxxs",
  "text": "ApplyFormGuardianConsent-module__k1CUkq__text",
  "title": "ApplyFormGuardianConsent-module__k1CUkq__title",
});
